
import ActsAsBanner from '@/mixins/ActsAsBanner';
import { resolvePathFromSegments } from '@/support';

export default {
  mixins: [ActsAsBanner],
};
